import React from "react";
import type { MenuItemSettings } from "../cards/WorkspaceCard/WorkspaceCard";
import MenuItem from "./MenuItem";
import Styles from "./MoreOptions.module.css";

type MoreOptionsProps = {
  menuItems: MenuItemSettings[];
};

export const MoreOptions: React.FC<MoreOptionsProps> = ({ menuItems }) => {
  return (
    <div className={Styles.moreOptions}>
      {menuItems.map((item) => (
        <MenuItem
          icon={item.icon}
          key={item.icon}
          label={item.label}
          onClick={item.onClick}
          title={item.title}
        />
      ))}
    </div>
  );
};
